import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const globals = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    alur_pendaftaran: [],
    queryParam: {},
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
    getAlurPendaftaran(state) {
      return state.alur_pendaftaran;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_ALUR_PENDAFTARAN(state, datas) {
      state.alur_pendaftaran = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async allByParam({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("globals/param/" + payload).then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },

    async pageByParam({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate(
        `globals/param/${payload[0]}/page`,
        payload[1]
      ).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },

    async alurPendaftaran({ commit }, payload) {
      return await Api.doGet("alur-pendaftaran").then(({ data }) => {
        commit("SET_ALUR_PENDAFTARAN", data);
        commit("SET_LOADING", false);
      });
    },

    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("globals/page", payload).then(({ data }) => {
        commit("SET_DATAS", data);
        commit("SET_LOADING", false);
      });
    },
  },
};

export default globals;
